import React, { useState, useEffect, useContext } from 'react';
import {
    Row,
    Col,
    Button,
    Table,
    Alert
} from 'reactstrap';
import axios from 'axios';
import { getCookie } from "../../jwt/_helpers";
import { StateContext } from '../../utils/context';
import { Trans, useTranslation } from 'react-i18next';

const API_URL = process.env.REACT_APP_API_URL_BASE;
const X_API_KEY = process.env.REACT_APP_X_API_KEY;

const StepFive = ({ jumpToStep }) => {
    const token = getCookie().token;
    const { currentUser } = useContext(StateContext);

    const { t } = useTranslation();

    const [verificationUrl, setVerificationUrl] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const initiateVerification = async () => {
        setIsLoading(true);
        try {
            const response = await axios.get(`${API_URL}users/initiate-identity-verification/`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "x-api-key": X_API_KEY,
                }
            });
            setVerificationUrl(response.data.url);
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            console.error('Verification initiation failed:', error);
        }
    };


    useEffect(() => {
        if(currentUser && currentUser.identity_verification_attempts<2 && verificationUrl === "") {
            initiateVerification();
        }
      }, [currentUser, verificationUrl])

    return (
        <div className="step step5 mt-5">
            {
                (currentUser && !currentUser.identity_verified) &&
                <Row className="justify-content-md-center">
                    <Col lg="6">
                        <center>
                            <br/><br/>
                            {t("userDataForm.view.stepFive.form.label.identityVerificationDescription")}
                            <br/><br/>
                            <Button
                                className="btn btn-ml"
                                style={{color: "#ffffff", backgroundColor: "#000a60"}}
                                disabled={isLoading || verificationUrl === "" || currentUser.identity_verification_attempts>=2}
                                onClick={() => {
                                    window.location.href = verificationUrl;
                                }}
                            >
                                {isLoading ? t("userDataForm.view.stepFive.form.button.loading") : t("userDataForm.view.stepFive.form.button.verifyIdentity")}
                            </Button>
                        </center>
                    </Col>
                </Row>
            }

            {
                (currentUser && currentUser.identity_info_submitted) &&
                <Row className="justify-content-md-center">
                    <Col lg="6">
                        <div className="results-container p-4">
                            <h3 className="text-center mb-4">{t("userDataForm.view.stepFive.form.label.identityVerificationResults")}</h3>
                            <Table bordered hover>
                                <thead>
                                    <tr>
                                        <th>{t("userDataForm.view.stepFive.form.table.column.type")}</th>
                                        <th>{t("userDataForm.view.stepFive.form.table.column.status")}</th>
                                        <th>{t("userDataForm.view.stepFive.form.table.column.details")}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{t("userDataForm.view.stepFive.form.label.selfieVerification")}</td>
                                        <td className={currentUser.identity_verification_results.selfie_verified ? 'text-success' : 'text-danger'}>
                                            {currentUser.identity_verification_results.selfie_verified ? t("userDataForm.view.stepFive.form.label.verified") : t("userDataForm.view.stepFive.form.label.notVerified")}
                                        </td>
                                        <td>
                                            {currentUser.identity_verification_results.selfie_error_reason || t("userDataForm.view.stepFive.form.label.notAvailable")}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>{t("userDataForm.view.stepFive.form.label.documentVerification")}</td>
                                        <td className={currentUser.identity_verification_results.document_verified ? 'text-success' : 'text-danger'}>
                                            {currentUser.identity_verification_results.document_verified ? t("userDataForm.view.stepFive.form.label.verified") : t("userDataForm.view.stepFive.form.label.notVerified")}
                                        </td>
                                        <td>
                                            {currentUser.identity_verification_results.document_error_reason || t("userDataForm.view.stepFive.form.label.notAvailable")}
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>

                            {
                                (currentUser && currentUser.identity_info_submitted && currentUser.identity_verified) &&
                                <Alert color="success">
                                    <Trans i18nKey="userDataForm.view.stepFive.message.identityVerificationSuccess">
                                        Your identity information has been verified, our team will review the identity information and give the final approval in 2-3 business days.
                                    </Trans>
                                </Alert>
                            }

                            {
                                (currentUser && currentUser.identity_info_submitted && currentUser.identity_verification_attempts<2 && !currentUser.identity_verified) &&
                                <Alert color="danger">
                                    <Trans i18nKey="userDataForm.view.stepFive.message.identityVerificationFailed" values={{attemptsRemaining: currentUser.identity_verification_attempts}}>
                                        Your identity information could not be verified, kindly submit the information again! You only have <strong>{currentUser.identity_verification_attempts}</strong> attempt remaining to verify your identity.
                                    </Trans>
                                </Alert>
                            }

                            {
                                (currentUser && !currentUser.identity_verified && currentUser.identity_verification_attempts>=2) &&
                                <Alert color="danger">
                                    <Trans i18nKey="userDataForm.view.stepFive.message.identityVerificationMaxAttempts">
                                        You have exhausted the maximum number of attempts for Identity Verification, please contact support for further information.
                                    </Trans>
                                </Alert>
                            }
                        </div>
                    </Col>
                </Row>
            }
        </div>
    );
};

export default StepFive;